import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";

export const getCustomizationAssets = (key) => {
  return getS3AssetCDNUrl(`assets/vectors/homepage/${key}`);
};
